import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { fbConfig } from '../config';
import 'firebase/storage';

const config =
  process.env.NODE_ENV === 'production'
    ? fbConfig.prodConfig
    : fbConfig.devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();
const db = firebase.database();
const storage = firebase.storage();

export { auth, db, storage };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js